/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService } from 'primeng/api';
import { AppUtils } from 'common/services/app.util';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-loginAdmin',
  templateUrl: './app.loginAdmin.component.html',
  styleUrls: ['./app.loginAdmin.component.css']
})
export class AppLoginAdminComponent {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  user: IUser;
  passwordType: string = "password";
  loading: boolean;
  tokenTimer: NodeJS.Timer;
  errorMessage: string = '';
  gymId: string = '';
  error: boolean = false;
  response: any;
  isDisableSignin: boolean = true;
  isCaptchaShow = false;

  constructor(
    private LanguageService: LanguageService,
    private appServicemanager: AppServiceManager,
    private route: Router,
    private messageService: MessageService
  ) {
    const currentUrl = window.location.href;
    console.log(currentUrl); // Output: "http://localhost:4200/#/loginAdmin"

    // if (currentUrl.includes('124.109.41.119:9090') || currentUrl.includes('192.168.100.204:6060')) {
    //   // production
    //   this.isCaptchaShow = true;
    // }
    // else {
    //   // staging
    //   this.isCaptchaShow = false;
    // }

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AppLoginAdminComponent", label);
  }
  ngOnInit() {
    this.user = new IUser();
    this.addRecaptchaScript();
    this.gymId = "";
  }
  togglePasswordType() {
    if (this.passwordType === "password") {
      this.passwordType = "text";
    } else {
      this.passwordType = "password";
    }
  }
  login() {
    this.loading = true;
    var dataSent = {
      email: this.user.email,
      password: this.user.password,
      gymId: this.gymId
    }
    this.appServicemanager.post('users/authenticateAdmin', dataSent).subscribe((res: any) => {
      if (res.error === null) {
        this.user = res.data.user;
        this.user.branch = this.gymId;
        this.user.company = res.data.company[0]._id;
        localStorage.setItem('currentUser', JSON.stringify(this.user));
        localStorage.setItem('currentRole', JSON.stringify(res.data.role));
        localStorage.setItem('currentCompany', JSON.stringify(res.data.company[0]));

        // calling img paths
        const appUtils = new AppUtils();
        appUtils.setImagesPath(this.user.company, this.user.branch);

        setTimeout(function () {
          // Code to be executed after the delay
          // This block of code will be executed after 1 second (1000 milliseconds)
        }, 1000);
        const token = res.data.token;
        const expiresInDuration = res.data.expiresIn;
        this.setAuthTimer(expiresInDuration);
        const now = new Date();
        const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);
        this.saveAuthData(token, expirationDate);
        this.route.navigateByUrl('members');
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: res.error });
      }
      this.loading = false;
    },
      (error) => {
        if (error.error === 'Your Licence is Expired' || error.error === 'Your Licence has been Deacivated' || error.error === 'MacAddress is Invalid') {
          this.loading = false;
          this.error = true;
          this.errorMessage = error.error;
          this.errorMessage = this.errorMessage + '!!' + '<br />' + " Contact Us" + '<br />' + "Email: rashid_562@hotmail.com"
            + '<br />' + " Contact No: 923335478182";
          this.loading = false;
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        }
      });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LeBcNofAAAAALKEmqYmmxrDJ7Fi9IpwDAPMVCtm',
      'expired-callback': () => {
        this.isDisableSignin = true;
        document.getElementById('gymId').focus();
      },
      'callback': (response) => {
        console.log(response);
        this.response = response;
        if (response == "") {
          this.isDisableSignin = true;
        } else {
          this.isDisableSignin = false;
          document.getElementById('gymId').focus();
        }
      }
    });
  }

  // verifyReCaptcha() {
  //   this.loading = true;
  //   let data = {
  //     token: this.response
  //   }
  //   this.appServicemanager.post('users/validateRecaptcha', data).subscribe((res: any) => {
  //     if (res.success) {
  //       this.login();
  //     } else {
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: res.error });
  //     }
  //   },
  //     (error) => {
  //   });
  // }

  verifyReCaptcha() {
    this.loading = true;
    let data = {
      token: this.response
    }
    this.appServicemanager.post('users/validateRecaptcha', data).subscribe((res: any) => {
      if (res.success) {
        this.login();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'reCAPTCHA failed' });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);
      });
  }

  logout() {
    this.clearAuthData();
    clearTimeout(this.tokenTimer as unknown as number);
    this.route.navigateByUrl('/login');
  }

  private setAuthTimer(duration: number) {
    console.log("Setting timer: " + duration);
    // this.tokenTimer = setTimeout(() => {
    //   this.logout();
    // }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date) {
    localStorage.setItem('token', JSON.stringify(token));
    localStorage.setItem('expiration', JSON.stringify(expirationDate.toISOString()));
  }

  private clearAuthData() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('currentCompany');
  }

}
